import { Box } from "@chakra-ui/react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

// Constants
import { CustomArrowProps } from "react-slick";

function SampleNextArrow(props: CustomArrowProps) {
  const { className, onClick } = props;

  return (
    <Box
      className={className}
      onClick={onClick}
      bg="brand.primary"
      borderRadius="50%"
      fontSize="2rem"
      h="32px"
      w="32px"
      _hover={{
        bg: "brand.primary",
      }}
    >
      <FiChevronRight color="white" />
    </Box>
  );
}

function SamplePrevArrow(props: CustomArrowProps) {
  const { className, onClick } = props;

  return (
    <Box
      className={className}
      onClick={onClick}
      bg="brand.primary"
      borderRadius="50%"
      fontSize="2rem"
      h="32px"
      w="32px"
      _hover={{
        bg: "brand.primary",
      }}
    >
      <FiChevronLeft color="white" width="20px" height="20px" />
    </Box>
  );
}

export const slickSettings = {
  className: "slick-view",
  edgeFriction: 1,
  swipeToSlide: true,
  infinite: false,
  speed: 500,
  slidesToShow: 2.1,
  slidesToScroll: 1,
  initialSlide: 0,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 2000,
      settings: {
        slidesToShow: 2.05,
        dots: false,
      },
    },
    {
      breakpoint: 1500,
      settings: {
        slidesToShow: 1.7,
        dots: false,
      },
    },
    {
      breakpoint: 1390,
      settings: {
        slidesToShow: 1.6,
        dots: false,
      },
    },
    {
      breakpoint: 1278,
      settings: {
        slidesToShow: 1.2,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2.2,
        dots: false,
      },
    },
    {
      breakpoint: 520,
      settings: {
        slidesToShow: 1.8,
        dots: true,
        nextArrow: undefined,
        prevArrow: undefined,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.35,
        dots: true,
        nextArrow: undefined,
        prevArrow: undefined,
      },
    },
    {
      breakpoint: 376,
      settings: {
        slidesToShow: 1.25,
        dots: true,
        nextArrow: undefined,
        prevArrow: undefined,
      },
    },
  ],
};
